<template>
  <div class="page-add">
    <div class="add-title">
      {{ addTitle }}
    </div>
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      :rules="rules"
      label-width="130px"
      class="form"
      size="small"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="弹窗类型：" prop="bizType" required>
            <el-select
              class="form-select"
              v-model="ruleForm.bizType"
              placeholder="请选择弹窗类型"
              @change="changeBizType"
            >
              <el-option
                v-for="item in popupBiztypeList"
                :key="Number(item.paramKey)"
                :label="item.paramValue"
                :value="Number(item.paramKey)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="ruleForm.bizType == 1">
        <el-col :span="12">
          <el-form-item label="关联直播：" prop="bizId" required>
            <load-select
              class="form-select"
              v-model="ruleForm.bizId"
              dictLabel="name"
              dictValue="uuid"
              :data="liveRoomData"
              :page="liveRoomPage"
              :hasMore="liveRoomMore"
              :request="getLiveRoomData"
              placeholder="请选择关联直播（输入名称以搜索）"
              :defaultVal="ruleForm.bizName"
              :isInit="isLiveRoomInit"
              @change="liveRoomChange"
              @ChangeValue="changeLiveRoom"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-else>
        <el-col :span="12">
          <el-form-item label="关联课程预约：" prop="bizId" required>
            <load-select
              class="form-select"
              v-model="ruleForm.bizId"
              dictLabel="name"
              dictValue="uuid"
              :data="courseTicketData"
              :page="courseTicketPage"
              :hasMore="courseTicketMore"
              :request="getCourseTicketData"
              placeholder="请选择关联课程预约（输入名称以搜索）"
              :defaultVal="ruleForm.bizName"
              :isInit="isCourseTicketInit"
              @change="courseTicketChange"
              @ChangeValue="changeCourseTicket"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="弹窗标题：" prop="name">
            <el-input
              type="textarea"
              placeholder="请输入弹窗标题"
              v-model="ruleForm.name"
              maxlength="50"
              autosize
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="弹窗提醒时间：" prop="popupDate">
            <el-date-picker
              unlink-panels
              v-model="ruleForm.popupDate"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 演讲人 -->
      <el-row>
        <el-col :span="12">
          <el-form-item label="演讲人：" prop="lecturerNamePost">
            <el-input
              placeholder="请输入演讲人"
              type="textarea"
              rows="8"
              v-model="ruleForm.lecturerNamePost"
              maxlength="1000"
              show-word-limit
            ></el-input>
            <div class="lecturePost">
              <el-button class="insetBtn" @click="insetSpace">首行缩进2格</el-button>
              <div class="tip_style1">演讲人介绍如需首行缩进2格，请点击该按钮</div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="课程开始时间：" prop="bizStartTime">
            <el-input
              placeholder="请输入课程开始时间"
              v-model="ruleForm.bizStartTime"
              maxlength="50"
            ></el-input>
            <div class="tip_style1">格式示例：4月15日（周二）19:00</div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item  label="是否启用倒计时：" required>
            <el-radio-group
              v-model="ruleForm.isCountdown"
              @input="changeCountDown"
            >
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="Number(item.paramKey)"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
            <el-col>
              <div class="tip_style1">备注：一般直播弹窗启用倒计时，预约弹窗不启用倒计时</div>
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="ruleForm.isCountdown == 1">
        <el-col :span="12">
          <el-form-item label="倒计时结束时间：" prop="countdownDate">
            <el-date-picker
              v-model="ruleForm.countdownDate"
              type="datetime"
              clearable
              placeholder="倒计时结束时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
            <div class="tip_style1">备注：倒计时结束时间一般为课程开始时间</div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="ruleForm.isCountdown == 1">
        <el-col :span="12">
          <el-form-item
            class="form_item"
            label="倒计时提示文案："
            prop="countdownDesc"
          >
            <el-input
              class="text_left"
              placeholder="请输入倒计时提示文案"
              v-model="ruleForm.countdownDesc"
              maxlength="14"
            ></el-input>
            <div class="text_right">XX 时 XX 分 XX 秒</div>
            <el-col>
              <div class="tip_style">备注： { } 内的提示文案，可以标红显示</div>
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label="弹窗提醒范围：" required>
            <el-radio-group v-model="ruleForm.limitType">
              <el-radio :key="2" :label="2">{{
                `与授权用户列表一致（通过授权范围开放的用户，无法同步至干部之家，进行指定用户直播弹窗提醒。）`
              }}</el-radio>
              <el-radio v-if="isShowRange" :key="1" :label="1"
                >全部用户</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item style="text-align: center">
            <el-button @click="reset">重置</el-button>
            <el-button @click="goBack">返回</el-button>
            <el-button type="primary" @click="onSubmit">提交</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import moment from "moment";
import {
  getPopupInfo,
  getCourseTicketSelectPage,
  getLiveRoomSelectPage,
  updatePopupInfo,
  savePopupInfo,
} from "@/api/liveRoom";
import { getSysParamByTypes } from "@/api/sysParam";
import LoadSelect from "@/components/load-select/index.vue";
import rulesFactory from "@/utils/rules";
import { setItem, getItem } from "@/utils/storage";

export default {
  components: {
    LoadSelect,
  },
  data() {
    return {
      isShowRange: false,
      data: [],
      addTitle: "新增/编辑弹窗",
      ruleForm: {
        bizType: null,
        name: "",
        popupDate: null,
        bizId: "",
        lecturerNamePost: "",
        bizStartTime: "",
        isCountdown: null,
        bizName: "",
        countdownDate: "",
        countdownDesc: "距离线上教学开始还有",
        limitType: 2,
        lecturerId: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入弹窗标题", trigger: "blur" },
          rulesFactory.size("最多输入50个字", 0, 50),
        ],
        popupDate: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || (!!value && value.length === 0)) {
                callback(new Error("请选择弹窗提醒时间"));
              } else if(moment(value[0]) >= moment(value[1])) {
                callback(new Error("结束时间需大于开始时间"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        bizId: [
          {
            required: true,
            message: "请选择",
            trigger: ["change", "blur"],
          },
        ],
        lecturerNamePost: [
          { required: true, message: "请输入演讲人", trigger: "blur" },
          rulesFactory.size("最多输入1000个字", 0, 1000),
        ],
        bizStartTime: [
          { required: true, message: "请输入课程开始时间", trigger: "blur" },
          rulesFactory.size("最多输入50个字", 0, 50),
        ],
        countdownDate: [
          { required: true, message: "请选择倒计时结束时间", trigger: "blur" },
        ],
        countdownDesc: [
          { required: true, message: "请输入倒计时提示文案", trigger: "blur" },
          rulesFactory.size("最多输入14个字", 0, 14),
        ],
      },
      resetForm: {},
      editFlag: false,
      publicData: [],
      liveRoomData: [],
      liveRoomMore: true,
      isLiveRoomInit: true,
      liveRoomPage: 1,
      courseTicketData: [],
      courseTicketMore: true,
      isCourseTicketInit: true,
      courseTicketPage: 1,
      popupBiztypeList: [],
    };
  },
  created() {
    let deptLevelCode = getItem("deptLevelCode");
    this.isShowRange = deptLevelCode == "001";
    this.getSysParamByTypes(["IS_VALID", "POPUP_BIZ_TYPE"]);
    if (this.$route.query.id) {
      this.editFlag = true;
      const id = this.$route.query.id;
      // 处理编辑或者详情
      this.getPopupDetail(id);
    } else {
      this.editFlag = false;
    }
  },
  methods: {
    goBack() {
      this.$router.push({ path: "/gbzjConfig", query: { active: 2 } });
    },
    // 修改弹窗类型
    changeBizType(val) {
      if (!!val) {
        this.ruleForm.name = "";
        this.ruleForm.bizId = "";
        this.ruleForm.bizName = "";
        this.ruleForm.popupDate = [];
        this.ruleForm.lecturerNamePost = "";
        this.ruleForm.lecturerId = "";
        this.ruleForm.bizStartTime = "";
        this.ruleForm.countdownDesc = `距离${
          val == 1 ? "线上教学" : "预约"
        }开始还有`;
      }
    },
    changeCountDown(val) {
      if (!!val) {
        this.ruleForm.countdownDesc = `距离${
          this.ruleForm.bizType == 1 ? "线上教学" : "预约"
        }开始还有`;
      }
    },
    getLiveRoomData({ page = 1, more = false, keyword = "" } = {}) {
      return new Promise((resolve) => {
        getLiveRoomSelectPage({ page, name: keyword })
          .then(({ code, data }) => {
            if (code !== 0) return;
            if (more) {
              this.liveRoomData = [...this.liveRoomData, ...data.records];
            } else {
              this.liveRoomData = data.records;
            }
            let { current, total, size } = data;
            this.liveRoomMore = this.liveRoomData.length < total;
            this.liveRoomPage = current;
            resolve();
          })
          .catch((_) => {
            resolve();
          });
      });
    },
    liveRoomChange(e) {
      this.isLiveRoomInit = false;
    },
    courseTicketChange(e) {
      this.isCourseTicketInit = false;
    },
    changeLiveRoom(val) {
      this.dealItemToForm(val)
    },
    changeCourseTicket(val) {
      
      this.dealItemToForm(val)
    },

    dealItemToForm(val) {
      if (!!val) {
        const list = this.ruleForm.bizType == 1 ? this.liveRoomData : this.courseTicketData;
        let item = list.filter((item) => item.uuid == val)[0];
        this.ruleForm.name = item.name;
        if (this.ruleForm.bizType == 1) {
          const startDate = moment(item.startDateStr).subtract(30, 'minutes').format('YYYY-MM-DD HH:mm:ss');
          this.ruleForm.popupDate = [startDate, item.endDateStr];
          this.ruleForm.bizStartTime = moment(item.startDateStr).format('MM月DD日（ddd）HH:mm');
        } else {
          this.ruleForm.popupDate = [item.ticketStartDateStr, item.ticketEndDateStr];
          this.ruleForm.bizStartTime = moment(item.startDateStr).format('MM月DD日（ddd）HH:mm');
        }
        this.ruleForm.lecturerNamePost = item.lecturerFullName;
        
        this.ruleForm.lecturerId = item.lecturerId;
        this.ruleForm.bizName = item.name;
      }
    },
    getCourseTicketData({ page = 1, more = false, keyword = "" } = {}) {
      return new Promise((resolve) => {
        getCourseTicketSelectPage({ page, name: keyword })
          .then(({ code, data }) => {
            if (code !== 0) return;
            if (more) {
              this.courseTicketData = [
                ...this.courseTicketData,
                ...data.records,
              ];
            } else {
              this.courseTicketData = data.records;
            }
            let { current, total, size } = data;
            this.courseTicketMore = this.courseTicketData.length < total;
            this.courseTicketPage = current;
            resolve();
          })
          .catch((_) => {
            resolve();
          });
      });
    },
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        // this.typeList = res.data["CLIENT_TYPE_BANNER"];
        this.publicData = res.data["IS_VALID"] || [];
        this.popupBiztypeList = res.data["POPUP_BIZ_TYPE"] || [];
        if (!this.$route.query.id) {
          this.ruleForm.bizType = Number(this.popupBiztypeList[0].paramKey);
          this.ruleForm.countdownDesc = "距离线上教学开始还有";
          this.ruleForm.isCountdown = Number(this.publicData[1].paramKey);
        }
      });
    },

    getPopupDetail(id) {
      getPopupInfo(id).then((res) => {
        if (!res || res.code != 0) return;
        const { data = {} } = res;
        const form = {
          ...data,
          popupDate: [data.popupStartDate, data.popupEndDate],
        };

        this.ruleForm = form;
        this.resetForm = JSON.parse(JSON.stringify(form));
      });
    },
    onSubmit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (!this.ruleForm.coverUrl) {
          this.showError = true;
        }

        if (valid) {
          this.$confirm(`确认提交吗？`, "系统提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              let params = { ...this.ruleForm };
              if (params.popupDate && params.popupDate.length > 1) {
                params.popupStartDate = this.ruleForm.popupDate[0];
                params.popupEndDate = this.ruleForm.popupDate[1];
              }
              delete params["popupDate"];
              delete params["streamingAddress"];
              delete params["streamingCode"];
              delete params["streamingSumAddress"];
              if (this.editFlag) {
                updatePopupInfo(params).then((res) => {
                  if (!res || res.code != 0) return;
                  setItem(this.REFRESH_FLAG, true);
                  this.$message.success(res.msg);
                  this.goBack();
                  this.$refs["ruleForm"].resetFields();
                });
              } else {
                savePopupInfo(params).then((res) => {
                  if (!res || res.code != 0) return;
                  setItem(this.REFRESH_FLAG, true);
                  this.$message.success(res.msg);
                  this.goBack();
                  this.$refs["ruleForm"].resetFields();
                });
              }
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    reset() {
      this.$confirm(`确认重置表单吗？`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (this.editFlag) {
            this.ruleForm = JSON.parse(JSON.stringify(this.resetForm));
          } else {
            Object.assign(this.$data.ruleForm, this.$options.data().ruleForm);
            this.ruleForm.bizType = Number(this.popupBiztypeList[0].paramKey);
            this.ruleForm.isCountdown = Number(this.publicData[1].paramKey);
            this.ruleForm.countdownDesc = "距离线上教学开始还有";
          }
        })
        .catch(() => {});
    },
    insetSpace() {
      this.ruleForm.lecturerNamePost = this.ruleForm.lecturerNamePost.split('\n').map(paragraph => {
          return `　　${paragraph.replace(/^\s*/, '')}`;
        }).join('\n');
    },
  },
};
</script>

<style lang="scss" scoped>
$textColor: #51627d;
$textSize: 14px;
.tip_style {
  font-size: 1rem;
  float: left;
  height: 36px;
  line-height: 36px;
  background-color: #eee;
  padding: 0 6px;
  margin-top: 4px;
}
.lecturePost {
  margin-top: 4px;
  display: flex;
  align-items: center;
  .insetBtn {
    margin-right: 12px;
  }
}
.tip_style1 {
  font-size: 1rem;
  margin-top: 4px;
  color: #999;
}
.text_left {
  width: calc(100% - 212px);
}
.text_right {
  margin-left: 12px;
  width: 200px;
  float: right;
}
.download_text {
  color: #3a85ff;
  // text-decoration: none;
}
.el-select__tags-text {
  font-size: 14px;
}

.autocomplete {
  width: 100%;
}

.el-autocomplete-suggestion {
  display: none;
}

.form-select {
  width: 100%;
}
/deep/ .el-range-editor--small.el-input__inner {
  width: 100%;
}
/deep/ .el-date-editor.el-input {
  width: 100%;
}
</style>
